// extracted by mini-css-extract-plugin
export default {"btn":"Contract_btn__TxysI","header":"Contract_header__fWlNY"};